import { IItinerary } from '../interfaces/itinerary.interface';

import { InitializeField } from './initialize-field.model';

export class Itinerary
  extends InitializeField<IItinerary>
  implements IItinerary
{
  name: string = '';
  description: string = '';
  short_description: string = '';

  settings: string = '';
  triptype: string = '';
  duration_range: string = '';
  duration: string = '';
  order: string = '';

  startCity: string = '';
  startCountry: string = '';
  endCity: string = '';
  endCountry: string = '';
  countries: string = '';
  countriesLen: string = '';

  image_url: string = '';
  imageTitle: string = '';
  imageLicense: string = '';
  imageOwner: string = '';
  imageOwnerUrl: string = '';
  imageSource: string = '';

  url: string = '';
  blogUrl: string = '';
  saves_id: string = '';

  protected excludedKeys: string[] = [];

  constructor(data: Partial<IItinerary> = {}) {
    super();
    this.initializeFields(data);
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      case 'name':
      case 'description':
      case 'short_description':
      case 'settings':
      case 'triptype':
      case 'duration_range':
      case 'duration':
      case 'order':
      case 'startCity':
      case 'startCountry':
      case 'endCity':
      case 'endCountry':
      case 'countries':
      case 'countriesLen':
      case 'image_url':
      case 'imageTitle':
      case 'imageLicense':
      case 'imageOwner':
      case 'imageOwnerUrl':
      case 'blogUrl':
      case 'imageSource':
      case 'url':
      case 'saves_id':
        return '';

      default:
        return null;
    }
  }
}
